import { render, staticRenderFns } from "./ErrorUnauthorized.vue?vue&type=template&id=70ffff01&"
import script from "./ErrorUnauthorized.vue?vue&type=script&lang=js&"
export * from "./ErrorUnauthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports